import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getBoundActions } from 'actions'
import { Map } from 'immutable'
import { H5 } from 'components/Heading'
import Button, { TYPES } from 'components/Button'

const CommentThreadReportModal = (props) => {
  const {
    onSubmit,
    staticText,
    dismissModal,
  } = props

  return (
    <div className="comment-thread-actions__report-modal">
      <H5 className="comment-thread-actions__report-modal-title">
        {staticText.get('sendReportTitle')}
      </H5>
      <div className="comment-thread-actions__report-modal-text">
        {staticText.get('sendReportConfirmText')}
      </div>
      <div className="comment-thread-actions__report-modal-buttons">
        <Button
          type={TYPES.SECONDARY}
          onClick={() => dismissModal()}
          stacked
        >
          {staticText.get('cancelButtonText')}
        </Button>
        <Button
          type={TYPES.PRIMARY}
          onClick={onSubmit}
          stacked
        >
          {staticText.get('submitButtonText')}
        </Button>
      </div>
    </div>
  )
}

CommentThreadReportModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  dismissModal: PropTypes.func.isRequired,
}

export default connect((state) => ({
  staticText: state.staticText.getIn(
    ['data', 'commentThreadActions', 'data'],
    Map(),
  ),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    dismissModal: actions.dialog.dismissModal,
  }
})(CommentThreadReportModal)
